import { Injectable } from '@angular/core';
import { FileUploaderInterface, FileUploadInfo } from '@vendasta/forms';
import { Observable, throwError } from 'rxjs';
import { MarketplaceAppService } from '@galaxy/marketplace-apps/v1';
import { map, take } from 'rxjs/operators';

export const defaultMaxFileSize = 524288000; // 500MB

@Injectable()
export class FileUploadService implements FileUploaderInterface {
  constructor(private marketplaceAppService: MarketplaceAppService) {}

  uploadFile(file: File): Observable<FileUploadInfo> {
    if (file.size > defaultMaxFileSize) {
      return throwError('File size too large');
    }

    return this.marketplaceAppService.uploadMarketingFile(file).pipe(
      take(1),
      map((fileUrl) => {
        return { url: fileUrl, name: file.name };
      }),
    );
  }
}
